import gql from 'graphql-tag';
import { customQueueFragment, myCustomQueueFragment } from './fragments';

export const customQueues = gql`
  query customQueues($partnerPersonContextId: Int!) {
    customQueues(partnerPersonContextId: $partnerPersonContextId) {
      ...customQueueParts
    }
  }
  ${customQueueFragment}
`;

export const myCustomQueues = gql`
  query myCustomQueues {
    myCustomQueues {
      customQueues {
        ...myCustomQueueParts
      }
      customEventTypes
    }
  }
  ${myCustomQueueFragment}
`;
